import styled from 'styled-components'

export const StyledResultLabel = styled.div`
  color: #92969a;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
`

export const StyledResultContainer = styled.div`
  display: inline-flex;
  padding: 16px 50px 16px 50px;
  border: 1px solid #ededed;
  border-radius: 4px;
  flex-direction: column;
  max-width: 80%;
  min-width: 420px;
  width: fit-content;
  margin-top: 16px;
  color: #044f98;
  font-size: 18px;
  font-weight: 600;
`

export const StyledResultRow = styled.div`
  display: inline-flex;
  flex-direction: row;
  gap: 20px;
  justify-content: space-between;
`

export const StyledButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 16px;
}
`
